<template>
  <div class="tableWithPerPageSelection">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()"
                class="column is-narrow">
            <b-input :placeholder="$t('general.button.search')"
                     type="search"
                     icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.COMMANDES.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="finChargement = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      v-if="finChargement && mountedLoadingEnd"
      @loaded="finLoading"
      @loading="debutLoading"
      class="overflow-x-auto"
      :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="lignesCommande">
        </table-footer-totaux>
      </template>
      <div slot="planMediaCode" slot-scope="props">
        <router-link-blank :to="{ name: 'c.presse.plan_media',
                    params: { id: props.row.planMediaId }}"
                           v-if="props.row.planMediaId"
                           :message="props.row.planMediaCode">
        </router-link-blank>
      </div>
      <div slot="codeDcf" slot-scope="props">
        <router-link-blank
          v-if="getRouteDevisCommande(props.row)"
          v-bind="getRouteDevisCommande(props.row)">
        </router-link-blank>
      </div>
        <div slot="lignesCommandeRegroupementLibelle" slot-scope="props">
          {{ props.row.lignesCommandeRegroupementLibelle }}
        </div>
      <div slot="libelle" slot-scope="props">
        {{ props.row.libelle }}
      </div>
      <div slot="type" slot-scope="props">
        {{ $t(getLibelleTypeDcf(props.row.type)) }}
      </div>
      <div slot="dateDevisCommande" slot-scope="props">
        {{ func.formatDate(props.row.dateDevisCommande) }}
      </div>
      <div slot="montantHtDcf" slot-scope="props" class="is-pulled-right"
           :class="{ 'textDecorationLineThrough':
             props.row.etatDcf === constantes.ETAT_CLOTURER
             || props.row.etatDcf === constantes.ETAT_SANSSUITE }">
        {{ props.row.montantHtDcf | formatDevise }}
      </div>
      <div slot="totalHtAvecLigneRemise" slot-scope="props" class="is-pulled-right"
           :class="{ 'textDecorationLineThrough':
             props.row.etatDcf === constantes.ETAT_CLOTURER
             || props.row.etatDcf === constantes.ETAT_SANSSUITE }">
        {{ props.row.totalHtAvecLigneRemise | formatDevise }}
      </div>
      <div slot="datePremierAffichage" slot-scope="props">
        {{ func.formatDate(props.row.datePremierAffichage) }}
      </div>
      <div slot="listeIntervenants" slot-scope="props">
        <router-link-blank
          v-for="(client, index) in props.row.clientsNomCommerciauxIds"
          :key="index"
          v-bind="getRouteClient(client)">
        </router-link-blank>
      </div>
      <div slot="etatDcf" slot-scope="props">
        {{ $t(props.row.etatLibelle) }}
      </div>
      <div slot="typeProduit" slot-scope="props">
        {{ $t(getLibelleCategorieProduit(props.row.typeProduit)) }}
      </div>
      <div slot="dateDebut" slot-scope="props">
        {{ func.formatDate(props.row.dateDebut) }}
      </div>
      <div slot="dateFin" slot-scope="props">
        {{ func.formatDate(props.row.dateFin) }}
      </div>
      <div slot="edit" slot-scope="props">
        <router-link-blank :to="{ name: 'm.bodac.commandes',
                    params: { id: props.row.devisCommandeId }}"
                           v-if="!props.row.interne"
                           icon="pencil-box-outline" typeIcon="is-success">
        </router-link-blank>
        <b-icon  icon="pencil-box-outline"
                 v-else
                 class="text-access-no-permission">
        </b-icon>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight"
                :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-lignes-commande
          ref="filtreListeLignesCommande"
          :fromProduit="produit !== null"
          :fromProduitLocationOrDivers="typeLocationOrDivers"
          :nameStore="nameStore"
          @toggleFiltre="changeValueShowFiltreAndLockMenu()"
          @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
  </div>
</template>
<script>

import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { RESET_STATE } from '@/store/mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import filtreListeLignesCommande from '@/components/bodac/lignesCommande/filtre/filtreListeLignesCommande';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import { SET_CRITERE } from '@/store/modules/bodac/commandeParligneCommande-mutation-type';
import {
  ETAT_SANSSUITE,
  ETAT_CLOTURER,
  TYPE_COMMANDE,
  TYPE_DEVIS,
  TYPE_FACTURE,
  LISTE_TYPE_DEVIS_COMMANDE_FACTURE,
} from '@/configuration/devisConf';
import checkPeriodeAndFormat from '@/services/dcf/checkPeriodeAndFormat';
import { get as getProduit } from '@/api/produit/index';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import { EXPORT_EXCEL_LIGNE_COMMANDE, STORE_NAME_PLAN_MEDIA_VENTE, STORE_NAME_COMMANDE_LIGNES_COMMANDE } from '@/configuration/commande/commandeConf';
import messageErreur from '@/services/general/messageErreur';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import { REFERENCE_TABLE_LIGNES_COMMANDES } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';
import formatDate from '@/services/general/formatDate';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { columnsSplice } from '@/services/general/columns';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      showFiltre: false,
      constantes: {
        COMMANDES,
        ETAT_SANSSUITE,
        ETAT_CLOTURER,
        EXPORT_EXCEL_LIGNE_COMMANDE,
        STORE_NAME_COMMANDE_LIGNES_COMMANDE,
        STORE_NAME_PLAN_MEDIA_VENTE,
      },
      finChargement: false,
      referenceTable: REFERENCE_TABLE_LIGNES_COMMANDES,
      resultPerPage: RESULTS_PER_PAGE,
      mountedLoadingEnd: false,
      func: {
        formatDate,
      },
    };
  },
  props: {
    nameStore: {
      type: String,
      required: false,
      default: STORE_NAME_COMMANDE_LIGNES_COMMANDE,
    },
    produit: {
      type: Object,
      required: false,
      default: null,
    },
    produitId: {
      type: String,
      required: false,
    },
    typeLocationOrDivers: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    TableItemsInView,
    filtreListeLignesCommande,
    routerLinkBlank,
    tableFooterTotaux,
    parametrageTable,
    exportExcelButton,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    lignesCommande() {
      return this.$store.getters[`${this.nameStore}/items`];
    },
    total() {
      return this.$store.getters[`${this.nameStore}/totalCount`];
    },
    lastPayload() {
      return this.$store.getters[`${this.nameStore}/lastPayload`];
    },
    criteresRecherche: {
      get() {
        return this.$store.getters[`${this.nameStore}/criteresRecherche`];
      },
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    nombreCritere() {
      const banCritere = ['auto', 'datesPremierAffichage', 'sens', 'interne'];
      banCritere.push(this.typeLocationOrDivers ? 'produitsIds' : 'produitRegroupementIds');
      let nbCritere = calculNombreCritere(this.criteresRecherche, banCritere);
      if (this.criteresRecherche.datesPremierAffichage) {
        nbCritere += this.criteresRecherche.datesPremierAffichage.dateDebut ? 1 : 0;
        nbCritere += this.criteresRecherche.datesPremierAffichage.dateFin ? 1 : 0;
      }
      nbCritere += this.criteresRecherche.interne !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    targetTotal() {
      return ['totalHtAvecLigneRemise'];
    },
    columns() {
      let cols = ['codeDcf', 'lignesCommandeRegroupementLibelle', 'libelle', 'type', 'dateDevisCommande', 'nomCommercial', 'listeIntervenants', 'etatDcf', 'datePremierAffichage', 'dateDebut', 'dateFin', 'codeDossier', 'totalHtAvecLigneRemise', 'montantHtDcf'];
      if (this.modulePlanMediaActive && this.$route.name !== 'c.presse.plan_media') {
        cols.splice(9, 1);
        cols.unshift('planMediaCode');
      }
      if (!this.produit) {
        cols.push('typeProduit', 'edit');
      }
      if (this.nameStore !== STORE_NAME_COMMANDE_LIGNES_COMMANDE) {
        cols = cols.filter(item => item !== 'codeDossier');
      } else {
        columnsSplice(cols, 'type');
      }

      return cols;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          planMediaCode: this.$i18n.t('listeLignesCommande.tabs.planMedia'),
          codeDossier: this.$i18n.t('listeLignesCommande.tabs.codeDossier'),
          dateDevisCommande: (this.nameStore === STORE_NAME_PLAN_MEDIA_VENTE) ? this.$i18n.t('listeLignesCommande.tabs.dateCommandePlanMVentes') : this.$i18n.t('listeLignesCommande.tabs.dateCommande'),
          montantHtDcf: (this.nameStore === STORE_NAME_PLAN_MEDIA_VENTE) ? this.$i18n.t('listeLignesCommande.tabs.montantHtPlanMVentes') : this.$i18n.t('listeLignesCommande.tabs.montantHt'),
          codeDcf: (this.nameStore === STORE_NAME_PLAN_MEDIA_VENTE) ? this.$i18n.t('listeLignesCommande.tabs.codeCommandePlanMVentes') : this.$i18n.t('listeLignesCommande.tabs.codeCommande'),
          etatDcf: (this.nameStore === STORE_NAME_PLAN_MEDIA_VENTE) ? this.$i18n.t('listeLignesCommande.tabs.etatPlanMVentes') : this.$i18n.t('listeLignesCommande.tabs.etat'),
          nomCommercial: this.$i18n.t('listeLignesCommande.tabs.commercial'),
          listeIntervenants: this.$i18n.t('listeLignesCommande.tabs.clients'),
          datePremierAffichage: this.$i18n.t('listeLignesCommande.tabs.dateCampagne'),
          totalHtAvecLigneRemise: this.$i18n.t('listeLignesCommande.tabs.totalHt'),
          dateDebut: this.$i18n.t('listeLignesCommande.tabs.dateDebut'),
          dateFin: this.$i18n.t('listeLignesCommande.tabs.dateFin'),
          libelle: this.$i18n.t('listeLignesCommande.tabs.produit'),
          lignesCommandeRegroupementLibelle: this.$i18n.t('listeLignesCommande.tabs.patrimoine'),
          typeProduit: this.$i18n.t('listeLignesCommande.tabs.typeProduit'),
          type: this.$i18n.t('listeLignesCommande.tabs.type'),
          edit: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['dateDevisCommande', 'libelle', 'montantHtDcf', 'etatDcf', 'planMediaCode', 'codeDcf', 'codeDossier', 'datePremierAffichage', 'type'],
        columnsClasses: {
          listeIntervenants: 'ellipsis colonneListeIntervenants',
        },
        rowClassCallback: ((row) => {
          return row.etatDcf === ETAT_CLOTURER || row.etatDcf === ETAT_SANSSUITE ? 'textDecorationLineThrough' : '';
        }),
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          this.gestionDataLoadLignesCommande(data);
          return this.actionsLoadLignesCommandes(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.lignesCommande,
            count: this.total,
          };
        }),
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: this.constantes.EXPORT_EXCEL_LIGNE_COMMANDE,
        typeExport: null,
        filtres: this.lastPayload,
      };
    },
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    actionsLoadLignesCommandes(data) {
      return this.$store.dispatch(`${this.nameStore}/loadLigneCommande`, data);
    },
    setCritereRecherche(criteres) {
      return this.$store.commit(`${this.nameStore}/${SET_CRITERE}`, criteres);
    },
    getLibelleCategorieProduit(typeProduit) {
      const typeProduitFind = CATEGORIE_PRODUIT.find((type) => {
        return type.code === typeProduit;
      });
      return typeProduitFind ? typeProduitFind.libelle : null;
    },
    getLibelleTypeDcf(typeDcf) {
      const typeDcfFind = LISTE_TYPE_DEVIS_COMMANDE_FACTURE.find((type) => {
        return type.code === typeDcf;
      });
      return typeDcfFind ? typeDcfFind.libelle : null;
    },
    gestionDataLoadLignesCommande(data) {
      checkPeriodeAndFormat(data.query, 'datesPremierAffichage');
      data.query.typesProduits = tagInputToArray(this.criteresRecherche.typesProduits, 'code');
      if (this.criteresRecherche.agencesId.length === 0) {
        data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
      }
      if (data.query.groupeIds.length > 0) {
        data.query.groupeIds = data.query.groupeIds.map((groupe) => { return groupe.id; });
      }
      if (data.query.enseigneIds.length > 0) {
        data.query.enseigneIds = data.query.enseigneIds.map((enseigne) => { return enseigne.id; });
      }
      if (data.query.fournisseursId.length > 0) {
        data.query.fournisseursId = data.query.fournisseursId.map((fournisseur) => {
          return fournisseur.id;
        });
      }
      if (data.query.tiersId.length > 0) {
        data.query.tiersId = data.query.tiersId.map((tiers => tiers.id));
      }
      if (this.$route.name === 'c.presse.plan_media'
        || this.$route.name === 'm.presse.plan_media-edit') {
        data.query.planMediaIds = [this.$route.params.id];
      }
      data.query.societeId = this.societeActiveId;
      if (data.query.produitsIds.length > 0) {
        data.query.produitsIds = data.query.produitsIds.map(produit => produit.id);
      }
      data.query.typesProduitRegroupement = tagInputToArray(this.criteresRecherche.typesProduitRegroupement, 'code');
      if (data.query.produitRegroupementIds.length > 0) {
        data.query.produitRegroupementIds = data.query.produitRegroupementIds
          .map(produit => produit.id);
      }
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeLignesCommande.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPageAndCheckChangement() {
      if (this.criteresRecherche.agencesId.length === 0) return;
      const agencesId = [];
      this.criteresRecherche.agencesId.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesId.push(id);
      });
      this.criteresRecherche.agencesId = agencesId;
      this.$refs[this.referenceTable].setPage(1);
    },
    async reinitialiser() {
      await this.$refs.filtreListeLignesCommande.initializeFiltre();
      await this.$refs.filtreListeLignesCommande.viderCritere();
      this.$refs.filtreListeLignesCommande.appliquerCritere();
      this.showFiltre = false;
    },
    getRouteDevisCommande(ligne) {
      if (!ligne.devisCommandeId) return null;
      const detail = {
        message: ligne.codeDcf,
        to: {
          name: 'c.bodac.commandes',
          params: { id: ligne.devisCommandeId },
        },
      };
      if (ligne.type === TYPE_COMMANDE && ligne.interne) detail.to.name = 'c.bodac.commandes-venteInterne';
      if (ligne.type === TYPE_DEVIS) detail.to.name = 'c.bodac.devis';
      if (ligne.type === TYPE_FACTURE) detail.to.name = 'c.bodac.factures';
      return detail;
    },
    getRouteClient(nomId) {
      return {
        to: {
          name: 'c.bodac.clients/contacts-client',
          params: {
            id: nomId.split('#')[1],
          },
        },
        message: nomId.split('#')[0],
      };
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.modulePlanMedia.key,
      ]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.goFirstPageAndCheckChangement, this.recherche);
      this.$store.commit(`${this.nameStore}/${RESET_STATE}`);
      const critere = cloneDeep(this.criteresRecherche);
      let produitTemp = this.produit;
      if (!produitTemp && this.produitId) {
        produitTemp = (await getProduit(this.produitId)).data.result;
      }
      if (this.typeLocationOrDivers && produitTemp) critere.produitsIds = [produitTemp];
      else if (!this.typeLocationOrDivers && produitTemp) {
        critere.produitRegroupementIds = [produitTemp];
      }
      await updateCritereWithParametreInterne(critere);
      const secteurIdsCurrentUser = (await getSecteursIdByUser(COMMERCIAL)).map(e => e.id);
      if (secteurIdsCurrentUser.length) critere.secteurIds = secteurIdsCurrentUser;
      this.setCritereRecherche(critere);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
